// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__+f-dY","brand":"Navigation_brand__nqz+v","links":"Navigation_links__sLq-f","header":"Navigation_header__UNj5Y"};